import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=294f2ee2&scoped=true"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"
import style0 from "./gallery.vue?vue&type=style&index=0&id=294f2ee2&scoped=true&lang=css"
import style1 from "./gallery.vue?vue&type=style&index=1&id=294f2ee2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f2ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294f2ee2')) {
      api.createRecord('294f2ee2', component.options)
    } else {
      api.reload('294f2ee2', component.options)
    }
    module.hot.accept("./gallery.vue?vue&type=template&id=294f2ee2&scoped=true", function () {
      api.rerender('294f2ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/gallery.vue"
export default component.exports